import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

interface GlobalConfigState {
  loading: boolean
  initFinished: boolean
  updateTime: Date
  mapOk: boolean
}

interface GlobalConfigActions {
  setLoading: (loading: boolean) => void
  setInitFinished: (initFinished: boolean) => void
  setUpdateTime: () => void
  setMapOk: () => void
}

let loadingCount: number = 0

const useGlobalConfigStore = create<GlobalConfigState & GlobalConfigActions>()(
  immer(set => ({
    loading: false,
    initFinished: false,
    updateTime: new Date(),
    mapOk: false,

    setLoading: loading => {
      if (loading) {
        loadingCount++
        if (loadingCount === 1) {
          set(state => {
            state.loading = true
          })
        }
      } else {
        loadingCount--
        if (loadingCount === 0) {
          set(state => {
            state.loading = false
          })
        } else if (loadingCount < 0) {
          loadingCount = 0
        }
      }
    },
    setInitFinished: initFinished =>
      set(state => {
        state.initFinished = initFinished
      }),
    setUpdateTime: () =>
      set(state => {
        state.updateTime = new Date()
      }),
    setMapOk: () => {
      set(state => {
        state.mapOk = true
      })
    },
  }))
)

export default useGlobalConfigStore
